import styled from 'styled-components';
import { device } from '../../../utils/styled-component-mixins';

const LocationsLandingSearchStyled = styled.div`
  .location-search-heading {
    > * {
      @media ${device.desktop} {
        text-align: center;
      }
    }

    h3 {
      margin-bottom: 1.6rem;
    }

    .location-search-subheading {
      margin-bottom: 4rem;

      p {
        font-size: 1.8rem;

        @media ${device.desktop} {
          font-size: 2rem;
        }
      }
    }
  }

  .location-search-input {
    display: flex;
    flex-direction: column;
    margin-bottom: 7.4rem;

    @media ${device.desktop} {
      align-items: center;
      flex-direction: row;
      justify-content: center;
      margin-bottom: 8rem;
    }

    > div {
      align-items: center;
      display: flex;
      margin-top: 1.6rem;

      @media ${device.desktop} {
        margin-top: 0;
      }

      > span {
        line-height: 2.4rem;
        margin: 0 1.6rem 0 0;

        @media ${device.desktop} {
          margin: 0 1.6rem;
        }
      }

      .btn-wrapper {
        display: block;
        span {
          display: block;
          height: 2.4rem;
        }
      }
    }
  }

  h3 {
    text-align: center;
  }

  .office-list {
    display: block;
    isolation: isolate;
    margin-bottom: 8rem;
    margin-top: 4rem;
    position: relative;
    width: 100%;

    @media ${device.desktop} {
      display: grid;
      gap: 1.6rem;
      grid: auto-flow / repeat(3, minmax(26rem, 1fr));
      margin-bottom: 16rem;
      padding-inline: 5.6rem;
    }

    .office-card {
      &::after {
        @media ${device.tablet} {
          box-shadow: var(--box-shadow);
          content: '';
          display: block;
          height: 100%;
          position: relative;
          top: -100%;
          width: 100%;
          z-index: -1;
        }
      }
    }
  }

  .office-slider {
    margin-bottom: 7.4rem;
    padding-block: 8rem 10rem;
    padding-inline: 1.75rem;

    @media ${device.mobileOnly} {
      margin: 0 -1.5rem 7.4rem -1.5rem;
      padding-bottom: 8rem;
      padding-top: 4rem;
      padding-inline: 0;
    }

    .swiper-slide {
      height: auto; // Fixes issue where cards stopped taking full height
      max-width: min(65rem, 66.66%);
      transform: unset !important;

      &::after {
        box-shadow: var(--box-shadow);
        content: '';
        display: block;
        height: 100%;
        position: relative;
        top: -100%;
        width: 100%;
        z-index: -1;
      }
      .widget-spacing-wrapper {
        margin-bottom: 0;
      }
    }

    .swiper-horizontal > .swiper-pagination-bullets,
    .swiper-pagination-bullets.swiper-pagination-horizontal {
      bottom: 4rem;
    }
  }

  .no-results-wrapper {
    margin-bottom: 16rem;
  }
`;

export default LocationsLandingSearchStyled;
